export const getCustomerInfoAction = (customerId)=>{
    return {type:"GET_CUSTOMER_INFO_ACTION",payload:customerId}
}

export const getCustomerInfoData = (infoDetails)=>{
    return {type:"CUSTOMET_INFO_DETAILS",payload:infoDetails}
}